
import {Component, Vue, Watch} from "vue-property-decorator";
import TamamlananGorevList from "@/components/lists/TamamlananGorevList.vue";
import DevamEdenGorevList from "@/components/lists/DevamEdenGorevList.vue";
import {Getter} from "vuex-class";

@Component({
  components:{DevamEdenGorevList, TamamlananGorevList}
})
export default class IslemlerView extends Vue {
  @Getter isTokenExis!: boolean;

  // Liste eİcraPro kimliği varken çekilir. Eskiden mount'ta koşulsuz çekiliyordu;
  // imzacı açılır açılmaz (kimlik gelmeden) giden istek proxy'de düşüyordu.
  // Kimlik sonradan gelince (updateToken, sağlık tiki) liste burada yüklenir.
  @Watch('isTokenExis', {immediate: true})
  onKimlikDegisti(kimlikVar: boolean) {
    if (kimlikVar) {
      this.$store.dispatch('getTasksFromServer').catch(() => undefined);
    }
  }
}
